import React, { useState } from 'react'
import { graphql } from 'gatsby'
import { Link } from 'gatsby'
import 'bootstrap/dist/css/bootstrap.css';
import '../styles/index.scss'
import { mapEdgesToNodes, filterOutDocsWithoutSlugs } from '../lib/helpers'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'
//import HeaderSecondary from '../components/header-secondary'

import BlockContent from '@sanity/block-content-to-react'


//import HeroImg from '../assets/img/hero-img.webp'
//import FbLogo from '../assets/img/fb-logo.svg'
//import HeroVideo from '../assets/img/lens-bg.mp4'
//import HeroVideoWeb from '../assets/img/lens-bg.webm'

import HeroVideo from '../assets/img/refract-bg_3.mp4'
import HeroVideoWeb from '../assets/img/refract-bg_3.webm'


export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }

    people: allSanityPerson(sort:{fields:[_createdAt], order: ASC }) {
      edges{
        node{
          id
          image{
            asset{
              url
            }
          }
          name
          title
          slug {
            current
          }
          _rawBio
          _rawExcerpt
        }
      }
    }

    posts: allSanityPost(limit: 6, sort: { fields: [publishedAt], order: DESC }) {
      edges {
        node {
          id
          publishedAt
          mainImage {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
            alt
          }
          title
          _rawExcerpt
          slug {
            current
          }
        }
      }
    }
  }
`

const IndexPage = props => {

  const [state, setState] = useState({
    selectedService: '1'
  });


  const { data, errors } = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const site = (data || {}).site

  const peopleNodes = (data || {}).people
    ? mapEdgesToNodes(data.people)
    : []

  const postNodes = (data || {}).posts
    ? mapEdgesToNodes(data.posts).filter(filterOutDocsWithoutSlugs)
    : []
  const projectNodes = (data || {}).projects
    ? mapEdgesToNodes(data.projects).filter(filterOutDocsWithoutSlugs)
    : []

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    )
  }

  const handleOptionChange = (changeEvent) => {
    setState({
      selectedService: changeEvent.target.value
    });
  };

  var selectedService;
  if (state.selectedService === '1') {
    selectedService =
      <div>
        <div className='serviceHeader'>Ophthalmic Education & Training</div>
        <ul>
          <li>New staff optician and technician training</li>
          <li>Staff development and advanced instruction</li>
          <li>Establish a process for efficient patient triage reducing doctor chair time</li>
        </ul>
      </div>
  } else if (state.selectedService === '2') {
    selectedService =
      <div>
        <div className='serviceHeader'>Patient Experience</div>
        <ul>
          <li>Increase loyalty and referrals by enhancing the patient experience</li>
          <li>Incorporating technology to impress and educate your patients</li>
          <li>Personalized eyewear selection and dispensing for ultimate comfort and vision</li>
          <li>Office design and merchandising to boost optical sales</li>
        </ul>
      </div>
  } else if (state.selectedService === '3') {
    selectedService =
      <div>
        <div className='serviceHeader'>Business Management</div>
        <ul>
          <li>Improve capture rate to increase profitability</li>
          <li>Develop Key Metrics to measure practice health and efficiency</li>
          <li>Maximize Optical Center flow and efficiency, reducing operating costs and improving patient satisfaction</li>
          <li>Build teamwork to create a positive practice culture and decrease staff turnover</li>
        </ul>
      </div>
  }

  return (

    <Layout>
      <SEO title={site.title} description={site.description} keywords={site.keywords} />
      <section className='hero' style={{ position: 'relative', marginBottom: '60px' }}>
        <div className='videoTag'>
          <div className='mobileScrim'></div>
          <video autoPlay loop muted playsInline>
            <source src={HeroVideoWeb} type='video/webm' />
            <source src={HeroVideo} type='video/mp4' />
          </video>
          </div>
        <Container>
          <div className='row align-self-center' style={{ marginTop: '50px' }}>
            <div className='col-md align-self-center'>
              <h1 id='heroText'>Empowering vision care professionals with personalized education and training.</h1>
              <Link className='linkBtn' to='/services/'>Learn more</Link>
              <div id='socialBlock' className='row'>
                <div id='socialText'>Connect with us</div>
                <div style={{ marginTop: '8px' }}>
                  <a id='fb-share' href='https://www.facebook.com/sightlineoc/' target='_blank'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M3 12C3 16.45 6.25 20.15 10.5 20.9L10.5505 20.8596C10.5337 20.8564 10.5168 20.853 10.5 20.8497V14.4997H8.25V11.9997H10.5V9.99968C10.5 7.74967 11.95 6.49967 14 6.49967C14.65 6.49967 15.35 6.59967 16 6.69967V8.99968H14.85C13.75 8.99968 13.5 9.54967 13.5 10.2497V11.9997H15.9L15.5 14.4997H13.5V20.8497C13.4832 20.853 13.4663 20.8564 13.4495 20.8596L13.5 20.9C17.75 20.15 21 16.45 21 12C21 7.05 16.95 3 12 3C7.05 3 3 7.05 3 12Z" fill="#0F0F37" />
                    </svg>
                  </a>
                  {<a id='ig-share' href='https://www.instagram.com/sightlineoc' target='_blank'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <linearGradient id="igGradent">
                          <stop offset="0%" stopColor="#F8ED34" />
                          <stop offset="50%" stopColor="#EA118D" />
                          <stop offset="100%" stopColor="#2E368F" />
                        </linearGradient>
                      </defs>
                      <path d="M12.0012 3.27344C9.63106 3.27344 9.33362 3.2838 8.40274 3.32616C7.47367 3.36871 6.83951 3.5158 6.28462 3.73162C5.71064 3.95453 5.22374 4.25271 4.73867 4.73798C4.25323 5.22307 3.95505 5.70998 3.73142 6.2838C3.51507 6.83889 3.3678 7.47326 3.32598 8.40198C3.28435 9.33289 3.27344 9.63053 3.27344 12.0007C3.27344 14.3709 3.28398 14.6674 3.32616 15.5983C3.36889 16.5274 3.51598 17.1616 3.73161 17.7165C3.95469 18.2905 4.25286 18.7774 4.73812 19.2625C5.22301 19.748 5.70991 20.0469 6.28353 20.2698C6.83878 20.4856 7.47313 20.6327 8.40201 20.6753C9.33289 20.7176 9.63015 20.728 12.0001 20.728C14.3704 20.728 14.6669 20.7176 15.5978 20.6753C16.5269 20.6327 17.1617 20.4856 17.717 20.2698C18.2908 20.0469 18.777 19.748 19.2619 19.2625C19.7473 18.7774 20.0455 18.2905 20.2691 17.7167C20.4836 17.1616 20.6309 16.5273 20.6745 15.5985C20.7164 14.6676 20.7273 14.3709 20.7273 12.0007C20.7273 9.63053 20.7164 9.33307 20.6745 8.40216C20.6309 7.47307 20.4836 6.83889 20.2691 6.28398C20.0455 5.70998 19.7473 5.22307 19.2619 4.73798C18.7764 4.25253 18.291 3.95435 17.7165 3.73162C17.1601 3.5158 16.5256 3.36871 15.5965 3.32616C14.6656 3.2838 14.3693 3.27344 11.9984 3.27344H12.0012ZM11.2183 4.84616C11.4506 4.8458 11.7099 4.84616 12.0012 4.84616C14.3313 4.84616 14.6075 4.85453 15.5276 4.89635C16.3785 4.93526 16.8403 5.07744 17.1479 5.19689C17.5552 5.35507 17.8455 5.54416 18.1508 5.84962C18.4563 6.15507 18.6453 6.44598 18.8039 6.85326C18.9233 7.16053 19.0657 7.62235 19.1044 8.47326C19.1462 9.39326 19.1553 9.66962 19.1553 11.9987C19.1553 14.3278 19.1462 14.6042 19.1044 15.5242C19.0655 16.3751 18.9233 16.8369 18.8039 17.1442C18.6457 17.5514 18.4563 17.8414 18.1508 18.1467C17.8454 18.4522 17.5554 18.6413 17.1479 18.7994C16.8407 18.9194 16.3785 19.0613 15.5276 19.1002C14.6076 19.142 14.3313 19.1511 12.0012 19.1511C9.67088 19.1511 9.39471 19.142 8.47473 19.1002C7.62385 19.0609 7.16205 18.9187 6.85424 18.7993C6.44698 18.6411 6.15608 18.452 5.85063 18.1465C5.54519 17.8411 5.3561 17.5509 5.19756 17.1434C5.07811 16.8362 4.93575 16.3743 4.89702 15.5234C4.85521 14.6034 4.84684 14.3271 4.84684 11.9965C4.84684 9.66598 4.85521 9.39107 4.89702 8.47107C4.93593 7.62016 5.07811 7.15835 5.19756 6.85071C5.35574 6.44344 5.54519 6.15253 5.85063 5.84707C6.15608 5.54162 6.44698 5.35253 6.85424 5.19398C7.16186 5.07398 7.62385 4.93216 8.47473 4.89307C9.2798 4.85671 9.59179 4.8458 11.2183 4.84398V4.84616ZM16.6596 6.29526C16.0814 6.29526 15.6123 6.7638 15.6123 7.34216C15.6123 7.92035 16.0814 8.38944 16.6596 8.38944C17.2377 8.38944 17.7068 7.92035 17.7068 7.34216C17.7068 6.76398 17.2377 6.29489 16.6596 6.29489V6.29526ZM12.0012 7.51889C9.52616 7.51889 7.51949 9.52562 7.51949 12.0007C7.51949 14.4758 9.52616 16.4816 12.0012 16.4816C14.4762 16.4816 16.4821 14.4758 16.4821 12.0007C16.4821 9.52562 14.476 7.51889 12.001 7.51889H12.0012ZM12.0012 9.09162C13.6077 9.09162 14.9102 10.394 14.9102 12.0007C14.9102 13.6073 13.6077 14.9098 12.0012 14.9098C10.3945 14.9098 9.09217 13.6073 9.09217 12.0007C9.09217 10.394 10.3945 9.09162 12.0012 9.09162Z" fill="#0F0F37" />
                    </svg>
                  </a>}
                  <a id='li-share' href='https://www.linkedin.com/company/sightline-oc' target='_blank'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.55123 8.41888C7.53309 8.41888 8.32903 7.62293 8.32903 6.64108C8.32903 5.65923 7.53309 4.86328 6.55123 4.86328C5.56938 4.86328 4.77344 5.65923 4.77344 6.64108C4.77344 7.62293 5.56938 8.41888 6.55123 8.41888Z" fill="#0F0F37" />
                      <path d="M9.95719 9.73274H12.9036V11.0825C12.9036 11.0825 13.7031 9.48341 15.8786 9.48341C17.8191 9.48341 19.4267 10.4394 19.4267 13.3533V19.4979H16.3734V14.0978C16.3734 12.3789 15.4557 12.1899 14.7564 12.1899C13.3052 12.1899 13.0567 13.4417 13.0567 14.3221V19.4979H9.95719V9.73274Z" fill="#0F0F37" />
                      <path d="M5.00148 9.7327H8.10099V19.4978H5.00148V9.7327Z" fill="#0F0F37" />
                    </svg>

                  </a>
                </div>
              </div>
            </div>
            <div className='col-md'>
              {/* <img id='heroImg' src={HeroImg} /> */}
              {/* {projectNodes && (
                  <ProjectPreviewGrid
                    title='Latest projects'
                    nodes={projectNodes}
                    browseMoreHref='/projects/'
                  />
                )}
                {postNodes && (
                  <BlogPostPreviewGrid
                    title='Latest blog posts'
                    nodes={postNodes}
                    browseMoreHref='/blog/'
                  />
                )} */}
            </div>
          </div>
        </Container>
      </section>
      <section id='services'>
        <Container>
          <div className='row'>
            <div className='col-md align-self-center'>
              {/* <h3>Services</h3> */}
              <ul className='serviceList'>
                <form>
                  <li>
                    <input id='service1' checked={state.selectedService === '1'} onChange={handleOptionChange} type='radio' value='1' />
                    <label htmlFor='service1'>Ophthalmic Education & Training</label>
                    <div className='mobileServiceList'>
                      <ul className={state.selectedService === '1' ? 'visible' : 'hidden'}>
                        <li>New staff optician and technician training</li>
                        <li>Staff development and advanced instruction</li>
                        <li>Establish a process for efficient patient triage reducing doctor chair time</li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <input id='service2' checked={state.selectedService === '2'} onChange={handleOptionChange} type='radio' value='2' />
                    <label htmlFor='service2'>Patient Experience</label>
                    <div className='mobileServiceList'>
                      <ul className={state.selectedService === '2' ? 'visible' : 'hidden'}>
                        <li>Increase loyalty and referrals by enhancing the patient experience</li>
                        <li>Incorporating technology to impress and educate your patients</li>
                        <li>Personalized eyewear selection and dispensing for ultimate comfort and vision</li>
                        <li>Office design and merchandising to boost optical sales</li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <input id='service3' checked={state.selectedService === '3'} onChange={handleOptionChange} type='radio' value='3' />
                    <label htmlFor='service3'>Business Management</label>
                    <div className='mobileServiceList'>
                      <ul className={state.selectedService === '3' ? 'visible' : 'hidden'}>
                        <li>Improve capture rate to increase profitability</li>
                        <li>Develop Key Metrics to measure practice health and efficiency</li>
                        <li>Maximize Optical Center flow and efficiency, reducing operating costs and improving patient satisfaction</li>
                        <li>Build teamwork to create a positive practice culture and decrease staff turnover</li>
                      </ul>
                    </div>
                  </li>
                </form>
              </ul>
            </div>
            <div className='col-md align-self-center lgServiceList'>
              {selectedService}
            </div>
          </div>
        </Container>
      </section>
      <section style={{ backgroundColor: '#FCF7F7' }}>
        <Container>
          <h3 style={{ textAlign: 'center', marginBottom: '16px', color: '#0F0F37' }}>Meet Our Team</h3>
          <div className='row'>
            {peopleNodes && (
              peopleNodes.map(node => (
                <div className='col-md-6 bioContainer' key={node.id}>
                  <div className='shortBio'>
                    <img src={node.image.asset.url} />
                    <div className='name'>
                      {node.name}
                    </div>
                    <div className='title'>
                      {node.title}
                    </div>
                    <BlockContent blocks={node._rawExcerpt} />
                    <Link className='bioLearnMore' to={`/about#${node.slug.current}`}>Learn more</Link>
                  </div>
                </div>
              ))
            )}
          </div>
        </Container>
      </section>

    </Layout>
  )
}

export default IndexPage
